import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import { App } from "./App";
import store from "./store";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<React.StrictMode>
		{/*TODO: change back to "/profitability-calculators" when building*/}
		<BrowserRouter basename="/profitability-calculators">
			<Provider {...{store}}>
				<App />
			</Provider>
		</BrowserRouter>
	</React.StrictMode>
);
